import React from 'react';
import { cn } from '../../utils/cn';

export const Tabs = ({ tabs, activeTab, onChange, className }) => {
  return (
    <div className={cn("flex p-1 bg-slate-100 rounded-2xl w-fit", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={cn(
            "px-6 py-2.5 text-sm font-bold rounded-xl transition-all duration-200 flex items-center gap-2",
            activeTab === tab.id
              ? "bg-white text-teal-600 shadow-sm"
              : "text-slate-500 hover:text-slate-700 hover:bg-white/50"
          )}
        >
          {tab.icon && tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
};